import { ActionTypes } from "../Constants/ActionTypes";

export const setLoggedInUserInformation = (dispatch, userInfo) => {
  dispatch({
    type: ActionTypes.SET_USER_INFORMATION,
    payload: userInfo,
  });
};

export const setLoggedInUserProfileImage = (dispatch, userInfo) => {
  dispatch({
    type: ActionTypes.SET_LOGGED_IN_USER_IMAGE,
    payload: userInfo,
  });
};

export const setSchoolName = (dispatch, userInfo) => {
  dispatch({
    type: ActionTypes.SET_SCHOOL_NAME,
    payload: userInfo,
  });
};

export const setAllWeekList = (dispatch, weekList) => {
  dispatch({
    type: ActionTypes.SET_WEEK_LIST,
    payload: weekList,
  });
};

export const setOpponentSchoolList = (dispatch, schoolList) => {
  dispatch({
    type: ActionTypes.SET_OPPONENT_SCHOOL_LIST,
    payload: schoolList,
  });
};

export const setFormHook = (dispatch, formHook) => {
  dispatch({
    type: ActionTypes.SET_FORM_HOOK,
    payload: formHook,
  });
};

export const toggleBuildSchedulePopup = (dispatch, status) => {
  dispatch({
    type: ActionTypes.TOGGLE_BUILD_SCHEDULE_POPUP,
    payload: status,
  });
};

export const setCurrentSeason = (dispatch, season) => {
  dispatch({
    type: ActionTypes.SET_CURRENT_SEASON,
    payload: season,
  });
};

export const setEditSchedule = (dispatch, status) => {
  dispatch({
    type: ActionTypes.SET_EDIT_SCHEDULE,
    payload: status,
  });
};

export const setScheduleInformation = (dispatch, information) => {
  dispatch({
    type: ActionTypes.SET_SCHEDULE_INFORMATION,
    payload: information,
  });
};

export const setCurrentSeasonInUserProfile = (dispatch, season) => {
  dispatch({
    type: ActionTypes.SET_CURRENT_SEASON_IN_USER_PROFILE,
    payload: season,
  });
};

export const addFmcToken = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ADD_FMC_TOKEN,
    payload: payload,
  });
};
